import { render, staticRenderFns } from "./VetalfaPanel.vue?vue&type=template&id=e9c86030"
import script from "./VetalfaPanel.vue?vue&type=script&lang=js"
export * from "./VetalfaPanel.vue?vue&type=script&lang=js"
import style0 from "./VetalfaPanel.vue?vue&type=style&index=0&id=e9c86030&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports